import React from "react";
import AdminSuiteConfirmationEmail from "./AdminSuiteConfirmationEmail";
import { AdminSuiteActionsProps } from "./AdminSuiteRequestsActions";

const AdminSuiteDeniedAction = (props: AdminSuiteActionsProps) => {
  return <AdminSuiteConfirmationEmail {...props} />;
};

export default AdminSuiteDeniedAction;
